var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgExternalLink = function SvgExternalLink(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 200,
    height: 200,
    viewBox: "0 0 1024 1024"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M204.8 136.533a68.267 68.267 0 0 0-68.267 68.267v614.4a68.267 68.267 0 0 0 68.267 68.267h614.4a68.267 68.267 0 0 0 68.267-68.267V580.267a34.133 34.133 0 0 0-68.267 0V819.2H204.8V204.8h238.933a34.133 34.133 0 0 0 0-68.267zm672.7 9.967a34.13 34.13 0 0 1 9.967 23.962v205.005a34.133 34.133 0 0 1-68.267 0V253.065L467.9 604.433a34.133 34.133 0 1 1-48.333-48.333l351.368-351.3H648.533a34.133 34.133 0 0 1 0-68.267h204.8A34.07 34.07 0 0 1 877.5 146.5"
  })));
};
export default SvgExternalLink;